import React, {useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faUsers, faClock, faPlay, 
  faCheckCircle, faServer, faCloud,
  faCode, faProjectDiagram, faLaptopCode, 
  faCertificate, faBriefcase, faCogs
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';

const Deveops = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('DevOps');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New DevOps Program</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">DevOps Engineering</span>
              </h1>
              <p className="hero-subtitle">
                Become a DevOps expert with our comprehensive certification program. 
                Gain hands-on experience with CI/CD pipelines, infrastructure as code, 
                and cloud automation for modern software delivery.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.9/5.0</div>
                    <small className="text-muted">(4,800 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">25,000+</div>
                    <small className="text-muted">Certified Engineers</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">120 hours</div>
                    <small className="text-muted">Hands-on Labs</small>
                  </div>
                </div>
              </div>
              
                <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="subcourses-images/devops.jpg" 
                  alt="DevOps Certification Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="course-details">
          <div className="course-content">
            {/* About Course */}
            <section className="about-course">
              <h2 className="section-title">About This Program</h2>
              <p>This comprehensive DevOps engineering program prepares you for cloud and automation roles. You'll gain expertise in continuous integration, infrastructure as code, containerization, and monitoring used by tech leaders.</p>
              <p>Through real-world projects and hands-on labs, you'll build the skills needed to implement DevOps practices and accelerate software delivery pipelines.</p>
            </section>
            
            {/* Curriculum */}
            <section className="curriculum">
              <h2 className="section-title">Learning Path</h2>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCogs} className="me-2" /> Module 1: DevOps Fundamentals</h3>
                <p>Master core DevOps principles and practices</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> DevOps culture & practices</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Version control with Git</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> CI/CD concepts</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Agile methodologies</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 2: Infrastructure as Code</h3>
                <p>Automate infrastructure provisioning</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Terraform fundamentals</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> CloudFormation</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Configuration management</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Policy as code</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 3: Cloud & Containerization</h3>
                <p>Implement cloud-native DevOps solutions</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Docker containers</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Kubernetes orchestration</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> AWS/GCP/Azure DevOps</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Serverless architectures</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 4: CI/CD Pipelines</h3>
                <p>Build automated delivery pipelines</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Jenkins pipelines</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> GitHub Actions</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> ArgoCD</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Pipeline security</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Monitoring & SRE</h3>
                <p>Implement observability and reliability</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Prometheus & Grafana</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> ELK stack</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> SLOs & SLIs</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Incident management</div>
                </div>
              </div>
            </section>
          </div>  
          
          <div className="course-sidebar">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="info-content">
                <h4>Duration</h4>
                <p>16 Weeks (20 hrs/week)</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faCertificate} />
              </div>
              <div className="info-content">
                <h4>Certifications</h4>
                <p>AWS Certified DevOps Engineer</p>
                <p>Kubernetes Administrator</p>
                <p>Terraform Associate</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faLaptopCode} />
              </div>
              <div className="info-content">
                <h4>Projects</h4>
                <p>6 Real-world Implementations</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="info-content">
                <h4>Prerequisites</h4>
                <p>Basic Linux & Scripting</p>
                <p>Cloud Fundamentals</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>
              <div className="info-content">
                <h4>Career Support</h4>
                <p>Resume Preparation</p>
                <p>DevOps Interview Coaching</p>
              </div>
            </div>
          <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">{formCourseName}</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Deveops;